import { useEffect, forwardRef } from 'react';
import { default as KeyboardLibraryComponent } from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

const CustomVirtualKeyboard = forwardRef((props, ref) => {
  const onKeyPress = (input) => {
    let evt = ''
    if (input.length <= 1) {
      let character = input.charAt(input.length - 1)
      evt = evt_key(character)
    } else {
      evt = evt_backspace
    }
    crossword_input.dispatchEvent(evt);
  }

  useEffect(() => {
    crossword_input = document.querySelector('[aria-label="crossword-input"]')
    if (crossword_input) {
      crossword_input.focus()
      ref.current.focus()
      if (window.screen.width < 768) {
        crossword_input.readOnly = true
      } else {
        crossword_input.readOnly = false
      }
    }
  })

  return (<div className="virtual-keyboard">
    <KeyboardLibraryComponent
      layoutName={'default'}
      layout={layout}
      display={display}
      onKeyPress={onKeyPress}
    />
  </div>
  )
})

let crossword_input;

const layout = {
  default: [
    "Q W E R T Y U I O P",
    "A S D F G H J K L Ç",
    "Z X C V B N M {backspace}"
  ],
  //'Just in case' purposes
  default_backup: [
    "q w e r t y u i o p",
    "a s d f g h j k l ç",
    "z x c v b n m {backspace}",
    "{space} {ent}"
  ],
  shift_backup: [
    "Q W E R T Y U I O P",
    "A S D F G H J K L Ç",
    "Z X C V B N M {backspace}",
    "{space} {ent}"
  ],
}

const display = {
  "{ent}": "enviar",
  "{backspace}": "⌫",
  "{space}": "espai"
}

const evt_backspace = new KeyboardEvent('keydown', {
  isTrusted: true,
  key: "Backspace",
  keyCode: 8,
  code: "Backspace",
  which: 8,
  shiftKey: false,
  ctrlKey: false,
  metaKey: false,
  cancelable: true,
  bubbles: true,
  charCode: 0
})
const evt_key = (character) => new KeyboardEvent('keydown', {
  isTrusted: true,
  key: character,
  keyCode: character.charCodeAt(0),
  code: "Key" + character.toUpperCase(),
  which: character.charCodeAt(0),
  shiftKey: false,
  ctrlKey: false,
  metaKey: false,
  cancelable: true,
  bubbles: true,
})

export default CustomVirtualKeyboard